import './index.css';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import CreateTeamPlayerRowKabaddi from '../create_team_player_row_kabaddi';
import { View, Text, FlatListWrapper } from '../../../component';
import FlatList from 'flatlist-react';
import { Key } from 'react';
import TeamSortingKabaddi from '../team_sorting_kabaddi';
import React from 'react';

interface Props {
  data: any;
  matchItem: any;
  onPressPlayer: any;
  selectedTab?: number;
  renderWhenEmpty: any;
  defenderList: any;
  allRounderList: any;
  raiderList: any;
  lineupsOut?: boolean;
  defenderListDisable?: boolean;
  allRounderListDisable?: boolean;
  raiderListDisable?: boolean;
  teamAPlayersCount?: number;
  teamBPlayersCount?: number;
  totalCreditCount?: number;
  substitutePlayers: any;
  sortName?: string;
  sortType?: string;
  onUpdateSortingList?: any;
}

const CreateTeamTabContentKabaddi = ({
  data,
  matchItem,
  onPressPlayer,
  selectedTab,
  renderWhenEmpty,
  defenderList,
  allRounderList,
  raiderList,
  lineupsOut,
  defenderListDisable,
  allRounderListDisable,
  raiderListDisable,
  teamAPlayersCount,
  teamBPlayersCount,
  totalCreditCount,
  substitutePlayers,
  sortName,
  sortType,
  onUpdateSortingList
}: Props) => {
  const { FantasyTheme: theme } = useTheme();

  const renderItemPlayer = (item: { id: Key | null | undefined }) => (
    <CreateTeamPlayerRowKabaddi
      matchItem={matchItem}
      item={item}
      key={item.id}
      onPressPlayer={onPressPlayer}
      lineupsOut={lineupsOut}
      defenderListDisable={defenderListDisable}
      allRounderListDisable={allRounderListDisable}
      raiderListDisable={raiderListDisable}
      teamAPlayersCount={teamAPlayersCount}
      teamBPlayersCount={teamBPlayersCount}
      totalCreditCount={totalCreditCount}
      substitutePlayers={substitutePlayers}
    />
  );

  const pick1 = {
    color: theme.createTeamSelectPlayerTitle
  };

  const pickLabel =
    selectedTab === 0
      ? I18n.t('PickDefenderKabaddi')
      : selectedTab === 1
      ? I18n.t('PickAllRounderKabaddi')
      : I18n.t('PickRaiderKabaddi');

  const pickLabelMessage =
    selectedTab === 0
      ? I18n.t('PickDefenderMaxMessageKabaddi')
      : selectedTab === 1
      ? I18n.t('PickAllRounderMaxMessageKabaddi')
      : I18n.t('PickRaiderMaxMessageKabaddi');

  return (
    <View className={'create-team-tab-content-wrapper'}>
      <View className={'create-team-tab-content-pick-player-wrapper'}>
        <Text className={'create-team-tab-content-pick-label'} style={pick1}>
          {`${pickLabel}`}
        </Text>
        <Text className={'create-team-tab-content-pick-message'} style={pick1}>
          &nbsp;&nbsp;-&nbsp;&nbsp;{pickLabelMessage}
        </Text>
      </View>

      <View className={'create-team-tab-content-sorting-header'}>
        <TeamSortingKabaddi
          defenderList={defenderList}
          allRounderList={allRounderList}
          raiderList={raiderList}
          sortName={sortName}
          sortType={sortType}
          onUpdateSortingList={onUpdateSortingList}
        />
      </View>

      <View className={'create-team-tab-content-flatlist'}>
        <FlatListWrapper className={'flat-list-padding'}>
          <FlatList
            list={data}
            renderItem={renderItemPlayer}
            renderOnScroll
            renderWhenEmpty={renderWhenEmpty}
          />
        </FlatListWrapper>
      </View>
    </View>
  );
};
CreateTeamTabContentKabaddi.defaultProps = {
  selectedTeamPlayers: [],
  isEdit: false,
  substitutePlayers: []
};
export default React.memo(CreateTeamTabContentKabaddi);
